import type { StateCreator } from 'zustand';
import type { DevicesSlices } from '.';

import type { DeviceAction } from '../../types';

interface DeviceModalSliceState {
  selectedAction: DeviceAction | null;
  lastLocationOpened: boolean;
  setSelectedAction: (action: DeviceAction) => void;
  clearSelectedAction: () => void;
  setLastLocationOpened: (opened: boolean) => void;
}

type StateCreatorDeviceModal = StateCreator<DevicesSlices, [['zustand/devtools', never]], [], DeviceModalSliceState>;

const createDeviceModalSlice: StateCreatorDeviceModal = (set) => ({
  selectedAction: null,
  lastLocationOpened: false,
  setSelectedAction: (action) => set({ selectedAction: action }),
  clearSelectedAction: () => set({ selectedAction: null }),
  setLastLocationOpened: (opened) => set({ lastLocationOpened: opened }),
});

export type { DeviceModalSliceState };
export default createDeviceModalSlice;
